import { db, auth } from '../firebase';
import { getOrCreateVoterId } from './voterService';

class InsufficientPointsError extends Error {
    constructor(message = 'Not enough points to vote') {
        super(message);
        this.name = 'InsufficientPointsError';
        this.code = 'INSUFFICIENT_POINTS';
    }
}

const updateVote = async (id, value) => {
    if (!db) return;

    const voterId = getOrCreateVoterId();
    const currentUser = auth.currentUser;

    if (!voterId) {
        throw new Error('No voter ID available');
    }

    // Update user's metadata and stats
    let pointsResult = { success: false };
    await db.ref(`users/${voterId}`).transaction((currentData) => {
        if (!currentData) {
            currentData = { points: 0, totalVotes: 0, isAuthenticated: !!currentUser };
        }

        const currentPoints = currentData.points || 0;
        const pointsToDeduct = Math.abs(value);

        if (currentPoints < pointsToDeduct) {
            pointsResult = { success: false, currentPoints };
            return currentData; // Abort - not enough points
        }

        pointsResult = { success: true, currentPoints: currentPoints - pointsToDeduct };

        return {
            ...currentData,
            points: currentPoints - pointsToDeduct,
            totalVotes: (currentData.totalVotes || 0) + Math.abs(value),
            lastActive: Date.now(),
            ...(currentUser && {
                displayName: currentUser.displayName,
                photoURL: currentUser.photoURL,
                isAuthenticated: true
            })
        };
    });

    if (!pointsResult.success) {
        throw new InsufficientPointsError();
    }

    // Then, update the vote count for the person
    await db.ref(`votes/${id}`).transaction(
        (currentData) => {
            if (currentData) {
                currentData.votes += value;
            } else {
                currentData = { votes: value };
            }
            return currentData;
        },
        (error) => {
            if (error) {
                console.error('Failed to update vote in transaction for id:', id, 'with value:', value, error);
            }
        }
    );
};

export const addVote = (id, value) => updateVote(id, Math.abs(value));

export const decreaseVote = (id, value) => updateVote(id, -Math.abs(value));

export { InsufficientPointsError };
